import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "../../../shared/i18n";

export default class CodeForm extends BaseModel {
  unique_code = null;
  code = null;
  type= null;
  remember_device= false;

  rules = {
    code: 'required',
    type: 'required',
  };

  attributeLabels = {
    code: i18n.t("Code"),
    type: i18n.t("Type"),
    remember_device: i18n.t("Remember this device for 30 days"),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
